/**
 * Centralized validation layer for contact updates
 * Provides field-level, payload-level, and inline edit validation
 */

export {
  validateContactField,
  validateContactUpdatePayload,
  type FieldValidation,
} from "./contact-field-validator";

export {
  validateInlineEdit,
  type InlineEditValidation,
} from "./inline-edit-validator";

export * from "./inline-edit-handler";
export * from "./schemas";
